import {ProjectFormikValue} from 'Interfaces'

export const Sort = (ed1: ProjectFormikValue, ed2: ProjectFormikValue) => {
  return ed1.endYear < ed2.endYear ? 1 : -1
}
